import { Link } from "react-router-dom";
import Styles from "./Styles/ImageArticlesListCard.module.css";
import blackBookmarkImage from "../../../../Assets/Icons/black-bookmark.png";
import blackSendMessageImage from "../../../../Assets/Icons/black-send-message.png";
import convertNumbersToPersian from "../../../../Utils/convertNumbersToPersian";
import messageIcon from "../../../../Assets/Icons/comments-count-dark.png";
import viewCountIcon from "../../../../Assets/Icons/view-count-dark.png";

const ImageArticlesListCard = ({
  item,
  handleChangePosts,
  handleShareArticle,
  handleSaveArticle,
  isList,
}) => {
  const {
    image,
    category,
    title,
    writer,
    _id,
    content,
    views,
    comments,
    kind,
  } = item;
  return (
    <div
      className={`${isList ? Styles.listsContainer : ""}  ${Styles.container}`}
    >
      <div
        className={Styles.imageContainer}
        style={!isList ? { height: "65%" } : {}}
      >
        <div
          className={Styles.imageTitle}
          onClick={() => handleChangePosts(item)}
        >
          {category}
        </div>
        <Link to={`/article/visual/${_id}`}>
          <img
            src={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${image}`}
            alt=""
          />
        </Link>
      </div>
      <h3
        className={Styles.title}
        style={!isList ? { marginTop: "50px", fontSize: "20px" } : {}}
      >
        {title}
      </h3>
      <div
        className={Styles.details}
        style={!isList ? { marginTop: "50px" } : {}}
      >
        <div className={Styles.socialsContainer}>
          <img
            src={blackBookmarkImage}
            alt=""
            onClick={() => handleSaveArticle(_id)}
            style={!isList ? { width: "30px", height: "30px" } : {}}
          />
          <img
            className={Styles.sendIcon}
            src={blackSendMessageImage}
            alt=""
            onClick={() =>
              handleShareArticle(
                `${process.env.REACT_APP_PUBLIC_URL}article/
                    visual
                  /${_id}`
              )
            }
            style={!isList ? { width: "30px", height: "30px" } : {}}
          />
          {/* <img src={blackHeartImage} alt="" /> */}
        </div>
        <div className={Styles.iconsContainer}>
          <div
            className={Styles.iconContainer}
            style={!isList ? { fontSize: "20px" } : {}}
          >
            <img
              className={Styles.messageIcon}
              style={!isList ? { width: "48px", height: "48px" } : {}}
              src={messageIcon}
              alt=""
            />
            <h5>{convertNumbersToPersian(comments.length.toString())}</h5>
          </div>
          <div
            className={Styles.iconContainer}
            style={!isList ? { fontSize: "20px" } : {}}
          >
            <img
              src={viewCountIcon}
              alt=""
              style={!isList ? { width: "35px", height: "35px" } : {}}
            />
            <h5>{convertNumbersToPersian(views.count.toString())}</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageArticlesListCard;
